export enum DocumentType {
  WithoutDocument = 0,
  DNI = 1,
  CNI = 2,
  NIN = 3,
  RUT = 4,
  Cedula = 5,
  DIMEX = 6,
  INE = 7,
  CURP = 8,
  Passport = 9,
  NIE = 10,
  CIF = 11,
  Other = 12,
  TWID = 13,
  TWARC = 14,
  PT_CARTAO = 15,
  TWWDA = 16
}

export const DOCUMENT_TYPE_OPTIONS = [
  { value: DocumentType.WithoutDocument, labelKey: 'document.types.withoutDocument' },
  { value: DocumentType.DNI, labelKey: 'document.types.dni' },
  { value: DocumentType.NIE, labelKey: 'document.types.nie' },
  { value: DocumentType.CNI, labelKey: 'document.types.cni' },
  { value: DocumentType.NIN, labelKey: 'document.types.nin' },
  { value: DocumentType.RUT, labelKey: 'document.types.rut' },
  { value: DocumentType.Cedula, labelKey: 'document.types.cedula' },
  { value: DocumentType.DIMEX, labelKey: 'document.types.dimex' },
  { value: DocumentType.INE, labelKey: 'document.types.ine' },
  { value: DocumentType.CURP, labelKey: 'document.types.curp' },
  { value: DocumentType.Passport, labelKey: 'document.types.passport' },
  { value: DocumentType.PT_CARTAO, labelKey: 'document.types.pt_cartao' },
  { value: DocumentType.CIF, labelKey: 'document.types.cif' },
  { value: DocumentType.TWID, labelKey: 'document.types.twid' },
  { value: DocumentType.TWARC, labelKey: 'document.types.twarc' },
  { value: DocumentType.TWWDA, labelKey: 'document.types.twwda' },
  { value: DocumentType.Other, labelKey: 'document.types.other' },
];
